"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Text_1 = require("../Text");
var DropdownOption_st_css_1 = require("./DropdownOption.st.css");
exports.DropdownOption = function (props) {
    var value = props.value, id = props.id, isSelectable = props.isSelectable, subtitle = props.subtitle, icon = props.icon, isSectionTitle = props.isSectionTitle;
    return (React.createElement("div", __assign({ key: id }, DropdownOption_st_css_1.default('root', {
        withIcon: !!icon,
        sectionTitle: isSectionTitle,
        selectable: isSelectable,
    }, props)),
        icon && React.createElement("div", { className: DropdownOption_st_css_1.default.icon }, icon),
        React.createElement("div", { className: DropdownOption_st_css_1.default.contentWrapper },
            React.createElement(Text_1.Text, { className: DropdownOption_st_css_1.default.title, typography: Text_1.TYPOGRAPHY.runningText }, value),
            subtitle && (React.createElement(Text_1.Text, { className: DropdownOption_st_css_1.default.subtitle, typography: Text_1.TYPOGRAPHY.runningText }, subtitle)))));
};
//# sourceMappingURL=DropdownOption.js.map